import FormHelperText from '@base/components/src/FormHelperText';
import WarningIcon from '@base/components/src/Icon/WarningIcon';
import { CouponCodeApiError } from '@package/core/src/couponCode/types';
import clsx from 'clsx';

import styles from './CouponCodeFormErrors.module.css';
import { CouponCodeFormErrorsProps } from './types';

const CouponCodeFormErrors = ({ error, className }: CouponCodeFormErrorsProps) => {
  if (error === null) return null;

  return (
    <>
      {error?.code === CouponCodeApiError.OneTimeCoupon && (
        <div
          id="coupon-error-message"
          className={clsx(
            styles.oneTimeCouponError,
            styles.couponErrorMessage,
            styles.errorAnimate,
            'warning',
            className,
          )}
        >
          {error?.message}
        </div>
      )}
      {error && error.code === CouponCodeApiError.Message && (
        <div id="coupon-error-message" className={clsx(styles.couponErrorMessage, styles.errorAnimate, className)}>
          {error?.message}
        </div>
      )}
      {error && (error.code === CouponCodeApiError.Error || error.code === CouponCodeApiError.CouponCodeUsed) && (
        <FormHelperText error>
          <div id="coupon-error-message" className={clsx(styles.couponErrorMessage, styles.errorAnimate, className)}>
            <span className={styles.warningIconContainer}>
              <WarningIcon />
            </span>
            {error?.message}
          </div>
        </FormHelperText>
      )}
    </>
  );
};

export default CouponCodeFormErrors;
